import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useMediaQuery } from "react-responsive";

export default function OurPartnersMini({ content }) {
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });
  const columnsNumber = items => `repeat(${items.length === 2 ? 2 : items.length / 2}, 1fr`;

  return (
    <div id="ourPartnersMini">
      <div className="subtitle">{content.subtitle}</div>
      <div className="title">{content.title}</div>
      {isMobile ? (
        <div className="wrapper">
          {[Math.floor((content.imageList?.length + 2) / 2)]
            .map(it => {
              let tmp = [];
              for (let i = 0; i < it; i++) {
                tmp.push(i);
              }
              return tmp;
            })[0]
            ?.map((gr, idxG) => {
              return (
                <div className="imgGroup" key={idxG}>
                  {content.imageList?.slice(gr * 2, gr * 2 + 2).map((image, i) => (
                    <div key={idxG + "_" + i} className="logo">
                      <LazyLoadImage alt="logo" effect="blur" src={image.media?.url} />
                    </div>
                  ))}
                </div>
              );
            })}
        </div>
      ) : (
        <div
          className={content.imageList.length >= 6 ? "gridPartners" : "linePartners"}
          style={{ gridTemplateColumns: columnsNumber(content.imageList) }}>
          {content.imageList?.map((image, i) => (
            <LazyLoadImage key={i} alt="logo" effect="blur" src={image.media?.url} />
          ))}
        </div>
      )}
    </div>
  );
}
